import { isNullOrEmpty } from "common/strings";
import Commodity from "./commodity";
import PositionGroup from "./positionGroup";

export class LocationBase {
  id: string = null;
  name: string = null;
}

export default class PhysicalLocation extends LocationBase {
  postalCode: string = null;
  grainAccountingId: string = null;
  fcmLocationId: string = null;
  homeLocation: LocationBase = null;
  bidGroup: string = null;
  marketZone: string = null;
  positionGroup: PositionGroup = null;
  commodities: Commodity[] = null;
  isDefaultBuyLocation: boolean = false;
}

export function isSelfOrChild(location: PhysicalLocation, id: string): boolean {
  return id === AllRegionsHomeLocation.id || location.homeLocation?.id === id || location.id === id;
}

export const AllRegionsHomeLocation: LocationBase = {
  id: 'ALL', 
  name: 'All Regions'
};

export function getPhysicalLocation (homeLocation: LocationBase) : PhysicalLocation {
  const physicalLocation: PhysicalLocation = {
    id: homeLocation.id,
    name: homeLocation.name,
    postalCode: null,
    grainAccountingId: null,
    fcmLocationId:  null,
    homeLocation: null,
    bidGroup: null,
    marketZone: null,
    positionGroup: null,
    commodities: null,
    isDefaultBuyLocation: false
  }
  return physicalLocation;
}

export function getPhysicalLocationDisplayName(location: PhysicalLocation, isCustomer: boolean = false): string {
  var displayName = ""
  if (location != null) {
    var displayName = location.name;
    if (!isCustomer && !isNullOrEmpty(location.grainAccountingId))
      displayName += ` - ${location.grainAccountingId}`;
  }
  return displayName;
}

